import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";
import { Formik } from "formik";
import PercentIcon from "@mui/icons-material/Percent";
import { Input, Radio, Select, InputNumber } from "formik-antd";
import axios from "axios";
import {
  Row,
  Col,
  Button,
  Divider,
  Typography,
  Space,
  DatePicker,
  Alert,
  message,
} from "antd";

import MultiStepFormContext from "./MultiStepFormContext";
import dayjs from "dayjs";
import moment from "moment";
import { Backdrop, CircularProgress } from "@mui/material";
import { stateOptions } from "../../utils/locationOptions";

const AssistanceRequirement = () => {
  const { assistanceRequirement, setAssistanceRequirement, next } =
    useContext(MultiStepFormContext);
  const monthFormat = "YYYY/MM";
  const { TextArea } = Input;
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [alertMessage, setAlertMessage] = useState("Data Saved Successfully!!");
  const [loading, setLoading] = useState(false);
  const [addressChecked] = useState(false);

  const handleClose = () => {
    setAlertVisible(false);
  };

  useEffect(() => {
    setvalue("tuitionFee", assistanceRequirement["tuitionFee"].value || 0);
    setvalue(
      "registrationFee",
      assistanceRequirement["registrationFee"].value || 0
    );
    setvalue(
      "examinationFee",
      assistanceRequirement["examinationFee"].value || 0
    );
    setvalue("hostelFee", assistanceRequirement["hostelFee"].value || 0);
    setvalue("foodExpenses", assistanceRequirement["foodExpenses"].value || 0);
    setvalue(
      "booksOtherEducationalMaterialExpenses",
      assistanceRequirement["booksOtherEducationalMaterialExpenses"].value || 0
    );
    setvalue(
      "otherExpenses1",
      assistanceRequirement["otherExpenses1"].value || 0
    );
    setvalue(
      "otherExpenses2",
      assistanceRequirement["otherExpenses2"].value || 0
    );
  }, []);

  function setvalue(key, value) {
    var x = assistanceRequirement;
    x[key].value = value;
    setAssistanceRequirement({ ...x });
  }
  const onChangeNumber = (item, value) => {
    setvalue(item, value);
  };

  const onChangeMonthYear = (item, date, dateString) => {
    if (dateString == "") {
      setvalue(item, undefined);
    } else {
      setvalue(item, moment(dateString).format(monthFormat));
    }
  };

  function setvisible(key) {
    var x = assistanceRequirement;
    x[key].visible = true;
    setAssistanceRequirement({ ...x });
  }

  function setrequired(key) {
    var x = assistanceRequirement;
    x[key].required = true;
    setAssistanceRequirement({ ...x });
  }

  function setnotrequired(key) {
    var x = assistanceRequirement;
    x[key].required = false;
    setAssistanceRequirement({ ...x });
  }

  function sethidden(key) {
    var x = assistanceRequirement;
    x[key].visible = false;
    setAssistanceRequirement({ ...x });
  }

  function onFinish(values) {
    next();
  }

  return (
    <>
      <Formik
        initialValues={assistanceRequirement}
        onSubmit={(values) => {
          setLoading(true);
          var url = window.API_PREFIX + "forms/api/post/education_assistance";
          const applicationId = sessionStorage.getItem("applicationId");

          if (!applicationId) {
            message.error("Failed to get application id", 5);
            // eslint-disable-next-line no-restricted-globals
            return location.reload();
          }

          const requestOptions = {
            data: {
              ...assistanceRequirement,
              courseEndDate: {
                ...assistanceRequirement.courseEndDate,
                value: dayjs(assistanceRequirement.courseEndDate.value).format(
                  "YYYY-MM-DD"
                ),
              },
              courseStartDate: {
                ...assistanceRequirement.courseStartDate,
                value: dayjs(
                  assistanceRequirement.courseStartDate.value
                ).format("YYYY-MM-DD"),
              },
            },
            applicationId: applicationId,
            user: sessionStorage.getItem("username"),
            token: sessionStorage.getItem("token"),
          };

          axios
            .post(url, requestOptions)
            .then((res) => {
              if (res.data.status == 200) {
                setAlertType("success");
                setAlertMessage(res.data.info);
                setAlertVisible(true);
              } else if (res.data.status == 409) {
                setAlertType("info");
                setAlertMessage(res.data.info);
                setAlertVisible(true);
              }
              onFinish();
            })
            .catch((err) => {
              message.error("There was some error submitting the form", 10);
            })
            .finally(() => {
              setLoading(false);
            });
        }}
        validateOnChange={true}
        validateOnBlur={true}
        validate={(values) => {
          const errors = {};
          values = assistanceRequirement;

          Object.keys(values).map((key) => {
            if (
              values[key]["required"] &&
              (values[key]["value"] === "" || values[key]["value"] === null)
            ) {
              errors[key] = _.capitalize(values[key]["label"]) + " is required";
            }

            if (key === "collegePincode" && values[key]["value"]) {
              const pinCodePattern = /^[1-9][0-9]{5}$/;
              if (!pinCodePattern.test(values[key]["value"])) {
                errors[key] = "Invalid PIN Code";
              }
            }

            if (key === "collegePhone" && values[key]["value"]) {
              const phonePattern = /^[0-9]{10}$/;
              if (!phonePattern.test(values[key]["value"])) {
                errors[key] = "Invalid Phone Number";
              }
            }

            if (key === "collegeEmail" && values[key]["value"]) {
              const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!emailPattern.test(values[key]["value"])) {
                errors[key] = "Invalid Email Address";
              }
            }

            if (key === "collegeWebsite" && values[key]["value"]) {
              const urlPattern =
                /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
              if (!urlPattern.test(values[key]["value"])) {
                errors[key] = "Invalid Website URL";
              }
            }

            if (key === "currentSemester" && values[key]["value"]) {
              const semesterValue = values[key]["value"];
              if (
                isNaN(semesterValue) ||
                semesterValue < 1 ||
                semesterValue > 10
              ) {
                errors[key] =
                  "Invalid Semester Number. It should be a number between 1 and 10.";
              }
            }

            if (key === "currentYear" && values[key]["value"]) {
              const currentYearOfCourse = values[key]["value"];
              const courseTotalDuration = values["courseDuration"]
                ? values["courseDuration"]["value"]
                : null;

              if (
                courseTotalDuration &&
                parseInt(courseTotalDuration) < parseInt(currentYearOfCourse)
              ) {
                errors[key] =
                  "Current year of course can not be greater than total course duration.";
              }
            }

            if (key === "courseDuration" && values[key]["value"]) {
              const semesterValue = values[key]["value"];
              if (
                isNaN(semesterValue) ||
                semesterValue < 1 ||
                semesterValue > 8
              ) {
                errors[key] = "Course duration can not be more than 8 years.";
              }
            }

            const currentYear = dayjs().year();
            if (key === "courseStartDate" && values[key]["value"]) {
              const startDate = values[key]["value"];
              const date1 = dayjs(startDate);
              const startYear = date1.year();
              const difference = currentYear - startYear;

              if (difference > 8) {
                errors[key] =
                  "Course start date cannot be more than 8 years ago.";
              }
              if (difference < -1) {
                errors[key] =
                  "Course start date cannot be more than 1 year in the future.";
              }
            }

            if (key === "courseEndDate" && values[key]["value"]) {
              const endDate = dayjs(values[key]["value"]);
              const currentDate = dayjs();
              const differenceInYears = endDate.diff(currentDate, "year");

              if (differenceInYears > 8) {
                errors[key] =
                  "Course end date cannot be more than 8 years in the future.";
              }
              if (differenceInYears < 0) {
                errors[key] =
                  "Course end date cannot be less than the current year.";
              }

              const startDate = values["courseStartDate"]
                ? dayjs(values["courseStartDate"]["value"])
                : null;
              if (startDate && endDate.isBefore(startDate)) {
                errors[key] =
                  "Course end date cannot be before the start date.";
              }

              const differenceInMonths = currentDate.diff(endDate, "month");
              if (differenceInMonths > 12) {
                errors[key] = "Course end date must be within the last year.";
              }
            }
          });

          return errors;
        }}
      >
        {({ handleSubmit, errors, touched }) => {
          return (
            <div>
              <Divider orientation="left" orientationMargin={50}>
                <Typography.Title level={5}>Course Details</Typography.Title>
              </Divider>
              <Row
                gutter={10}
                style={{
                  marginLeft: "50px",
                  marginRight: "5px",
                }}
              >
                {Object.keys(assistanceRequirement).map((item) => {
                  return (
                    <>
                      {assistanceRequirement[item].type == "text" &&
                      assistanceRequirement[item].field_set ==
                        "Basic Education Details" ? (
                        <>
                          <Col md={assistanceRequirement[item].col}>
                            <label>
                              {assistanceRequirement[item].label}{" "}
                              {assistanceRequirement[item].required ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </label>
                            <Input
                              placeholder={assistanceRequirement[item].label}
                              onChange={(e) => {
                                setvalue(item, e.target.value);
                              }}
                              name={`${item}.value`}
                              value={assistanceRequirement[item].value}
                            />
                            {errors[item] &&
                            item in touched &&
                            touched[item]["value"] ? (
                              <div style={{ color: "red" }}>{errors[item]}</div>
                            ) : null}
                          </Col>
                        </>
                      ) : (
                        <>
                          {assistanceRequirement[item].type == "number" &&
                          assistanceRequirement[item].field_set ==
                            "Basic Education Details" ? (
                            <>
                              <Col md={assistanceRequirement[item].col}>
                                <label>
                                  {assistanceRequirement[item].label}{" "}
                                  {assistanceRequirement[item].required ? (
                                    <span style={{ color: "red" }}>*</span>
                                  ) : null}
                                </label>
                                <Input
                                  type="number"
                                  style={{ width: "100%" }}
                                  placeholder={
                                    assistanceRequirement[item].label
                                  }
                                  onChange={(e) =>
                                    onChangeNumber(item, e.target.value)
                                  }
                                  name={`${item}.value`}
                                  min={0}
                                  value={assistanceRequirement[item].value}
                                />
                                {errors[item] &&
                                item in touched &&
                                touched[item]["value"] ? (
                                  <div style={{ color: "red" }}>
                                    {errors[item]}
                                  </div>
                                ) : null}
                              </Col>
                            </>
                          ) : (
                            <>
                              {assistanceRequirement[item].type == "select" &&
                              assistanceRequirement[item].field_set ==
                                "Basic Education Details" ? (
                                <>
                                  <Col md={assistanceRequirement[item].label}>
                                    <label>
                                      {assistanceRequirement[item].label}{" "}
                                      {assistanceRequirement[item].required ? (
                                        <span style={{ color: "red" }}>*</span>
                                      ) : null}
                                    </label>
                                    <Select
                                      style={{ width: "100%" }}
                                      placeholder={
                                        assistanceRequirement[item].label
                                      }
                                      name={`${item}.value`}
                                      // options={item.option_item}
                                      onChange={(e) => {
                                        setvalue(item, e);
                                      }}
                                    >
                                      <Select.Option value={"Govt.College"}>
                                        Government College
                                      </Select.Option>
                                      <Select.Option value={"Semi-Government"}>
                                        Semi-Government
                                      </Select.Option>
                                      <Select.Option value={"Private"}>
                                        Private
                                      </Select.Option>
                                    </Select>
                                    {errors[item] &&
                                    item in touched &&
                                    touched[item]["value"] ? (
                                      <div style={{ color: "red" }}>
                                        {errors[item]}
                                      </div>
                                    ) : null}
                                  </Col>
                                </>
                              ) : (
                                <>
                                  {assistanceRequirement[item].type ==
                                    "month_year" &&
                                  assistanceRequirement[item].field_set ==
                                    "Basic Education Details" ? (
                                    <>
                                      <Col
                                        md={assistanceRequirement[item].label}
                                      >
                                        <label>
                                          {assistanceRequirement[item].label}{" "}
                                          {assistanceRequirement[item]
                                            .required ? (
                                            <>
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </>
                                          ) : null}
                                        </label>
                                        <DatePicker
                                          name={`${item}.value`}
                                          value={
                                            assistanceRequirement[item].value
                                              ? dayjs(
                                                  assistanceRequirement[item]
                                                    .value
                                                )
                                              : ""
                                          }
                                          picker="date"
                                          popupAlign={{ points: ["br bb"] }}
                                          onChange={(date, dateString) =>
                                            setvalue(item, dateString)
                                          }
                                        />
                                        {errors[item] &&
                                        item in touched &&
                                        touched[item]["value"] ? (
                                          <div style={{ color: "red" }}>
                                            {errors[item]}
                                          </div>
                                        ) : null}
                                      </Col>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  );
                })}
              </Row>
              <Divider orientation="left" orientationMargin={50}>
                <Typography.Title level={5}>College Address</Typography.Title>
              </Divider>
              <Row
                gutter={10}
                style={{ marginLeft: "50px", marginRight: "5px" }}
              >
                {Object.keys(assistanceRequirement).map((item) => {
                  return (
                    <>
                      {(assistanceRequirement[item].type == "text" ||
                        assistanceRequirement[item].type == "number") &&
                      assistanceRequirement[item].visible &&
                      assistanceRequirement[item].field_set ==
                        "College Address Details" ? (
                        <>
                          {assistanceRequirement[item].label ===
                          "College State" ? (
                            <Col md={assistanceRequirement[item].col}>
                              <label>
                                {assistanceRequirement[item].label}{" "}
                                {assistanceRequirement[item].required ? (
                                  <span style={{ color: "red" }}>*</span>
                                ) : null}
                              </label>
                              <Select
                                showSearch
                                placeholder="Select state"
                                optionFilterProp="label"
                                value={assistanceRequirement[item].value}
                                onChange={(val) => {
                                  setvalue(item, val);
                                  if (addressChecked) {
                                    setvalue(
                                      assistanceRequirement[item].copyTo,
                                      val
                                    );
                                  }
                                }}
                                style={{
                                  width: "100%",
                                }}
                                options={stateOptions}
                              />
                              {errors[item] &&
                              item in touched &&
                              touched[item]["value"] ? (
                                <div style={{ color: "red" }}>
                                  {errors[item]}
                                </div>
                              ) : null}
                            </Col>
                          ) : (
                            <Col md={assistanceRequirement[item].col}>
                              <label>
                                {assistanceRequirement[item].label}{" "}
                                {assistanceRequirement[item].required ? (
                                  <span style={{ color: "red" }}>*</span>
                                ) : null}
                              </label>
                              <Input
                                type={assistanceRequirement[item].type}
                                placeholder={assistanceRequirement[item].label}
                                name={`${item}.value`}
                                value={assistanceRequirement[item].value}
                                onChange={(e) => {
                                  setvalue(item, e.target.value);
                                }}
                                min={0}
                              />
                              {errors[item] &&
                              item in touched &&
                              touched[item]["value"] ? (
                                <div style={{ color: "red" }}>
                                  {errors[item]}
                                </div>
                              ) : null}
                            </Col>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  );
                })}
              </Row>
              <Divider orientation="left" orientationMargin={50}>
                <Typography.Title level={5}>
                  College Expense Details (per year)
                </Typography.Title>
              </Divider>
              <Row
                gutter={10}
                style={{ marginLeft: "50px", marginRight: "5px" }}
              >
                {Object.keys(assistanceRequirement).map((item) => {
                  return (
                    <>
                      {(item === "otherExpenses1" ||
                        item === "otherExpenses2") &&
                        assistanceRequirement[item].field_set ==
                          "College Expense Details" && (
                          <>
                            <Col md={assistanceRequirement[item].col}>
                              <label>
                                {assistanceRequirement[item].label}
                                {assistanceRequirement[item].required ? (
                                  <span style={{ color: "red" }}>*</span>
                                ) : null}
                              </label>
                              <Input
                                placeholder={assistanceRequirement[item].label}
                                onChange={(e) => {
                                  setvalue(item, e.target.value);
                                }}
                                name={`${item}.value`}
                                value={assistanceRequirement[item].value}
                              />
                              {errors[item] &&
                              item in touched &&
                              touched[item]["value"] ? (
                                <div style={{ color: "red" }}>
                                  {errors[item]}
                                </div>
                              ) : null}
                            </Col>
                          </>
                        )}
                      {assistanceRequirement[item].type == "textArea" &&
                      assistanceRequirement[item].field_set ==
                        "College Expense Details" ? (
                        <>
                          <Col md={assistanceRequirement[item].col}>
                            <label>
                              {assistanceRequirement[item].label}{" "}
                              {assistanceRequirement[item].required ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </label>
                            <TextArea
                              placeholder={assistanceRequirement[item].label}
                              rows={4}
                              maxLength={assistanceRequirement[item].max_length}
                              name={`${item}.value`}
                              value={assistanceRequirement[item].value}
                              onChange={(e) => {
                                setvalue(item, e.target.value);
                              }}
                            />
                            {errors[item] &&
                            item in touched &&
                            touched[item]["value"] ? (
                              <div style={{ color: "red" }}>{errors[item]}</div>
                            ) : null}
                          </Col>
                        </>
                      ) : (
                        <>
                          {assistanceRequirement[item].type == "number" &&
                          assistanceRequirement[item].field_set ==
                            "College Expense Details" ? (
                            <>
                              <Col md={assistanceRequirement[item].col}>
                                <label>
                                  {assistanceRequirement[item].label}
                                  {assistanceRequirement[item].required ? (
                                    <span style={{ color: "red" }}>*</span>
                                  ) : null}
                                </label>
                                <InputNumber
                                  type="number"
                                  style={{ width: "100%" }}
                                  placeholder={
                                    assistanceRequirement[item].label
                                  }
                                  disabled={
                                    assistanceRequirement[item].disabled
                                  }
                                  onChange={(e) => onChangeNumber(item, e)}
                                  name={`${item}.value`}
                                  min={0}
                                  value={assistanceRequirement[item].value}
                                />
                                {errors[item] &&
                                item in touched &&
                                touched[item]["value"] ? (
                                  <div style={{ color: "red" }}>
                                    {errors[item]}
                                  </div>
                                ) : null}
                              </Col>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </>
                  );
                })}
              </Row>
              <Divider orientation="left" orientationMargin={50}>
                <Typography.Title level={5}>
                  Other Assistance Related Details
                </Typography.Title>
              </Divider>
              <Row
                gutter={10}
                style={{ marginLeft: "50px", marginRight: "5px" }}
              >
                {Object.keys(assistanceRequirement).map((item) => {
                  return (
                    <>
                      {assistanceRequirement[item].type == "text" &&
                      assistanceRequirement[item].field_set ==
                        "Other Details" &&
                      assistanceRequirement[item].visible ? (
                        <>
                          <Col md={assistanceRequirement[item].col}>
                            <label>
                              {assistanceRequirement[item].label}{" "}
                              {assistanceRequirement[item].required ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </label>
                            <Input
                              placeholder={assistanceRequirement[item].label}
                              onChange={(e) => {
                                setvalue(item, e.target.value);
                              }}
                              name={`${item}.value`}
                              value={assistanceRequirement[item].value}
                            />
                            {errors[item] &&
                            item in touched &&
                            touched[item]["value"] ? (
                              <div style={{ color: "red" }}>{errors[item]}</div>
                            ) : null}
                          </Col>
                        </>
                      ) : (
                        <>
                          {assistanceRequirement[item].type == "number" &&
                          assistanceRequirement[item].field_set ==
                            "Other Details" &&
                          assistanceRequirement[item].visible ? (
                            <>
                              {assistanceRequirement[item].label ==
                              "If yes, what percentage of the Education Assistance amount would you be willing to repay?" ? (
                                <>
                                  <Col md={assistanceRequirement[item].col}>
                                    <label>
                                      {assistanceRequirement[item].label}{" "}
                                      {assistanceRequirement[item].required ? (
                                        <span style={{ color: "red" }}>*</span>
                                      ) : null}
                                    </label>
                                    <InputNumber
                                      type="number"
                                      style={{ width: "100%" }}
                                      addonAfter={
                                        <PercentIcon fontSize="10px" />
                                      }
                                      placeholder={
                                        assistanceRequirement[item].label
                                      }
                                      min={0}
                                      max={100}
                                      onChange={(e) => onChangeNumber(item, e)}
                                      name={`${item}.value`}
                                      value={assistanceRequirement[item].value}
                                    />
                                    {errors[item] &&
                                    item in touched &&
                                    touched[item]["value"] ? (
                                      <div style={{ color: "red" }}>
                                        {errors[item]}
                                      </div>
                                    ) : null}
                                  </Col>
                                </>
                              ) : (
                                <>
                                  <Col md={assistanceRequirement[item].col}>
                                    <label>
                                      {assistanceRequirement[item].label}{" "}
                                      {assistanceRequirement[item].required ? (
                                        <span style={{ color: "red" }}>*</span>
                                      ) : null}
                                    </label>
                                    <InputNumber
                                      type="number"
                                      style={{ width: "100%" }}
                                      placeholder={
                                        assistanceRequirement[item].label
                                      }
                                      min={0}
                                      onChange={(e) => onChangeNumber(item, e)}
                                      name={`${item}.value`}
                                      value={assistanceRequirement[item].value}
                                    />
                                    {errors[item] &&
                                    item in touched &&
                                    touched[item]["value"] ? (
                                      <div style={{ color: "red" }}>
                                        {errors[item]}
                                      </div>
                                    ) : null}
                                  </Col>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {assistanceRequirement[item].type == "radio" &&
                              assistanceRequirement[item].field_set ==
                                "Other Details" &&
                              assistanceRequirement[item].visible ? (
                                <>
                                  <Col md={assistanceRequirement[item].col}>
                                    <label>
                                      {assistanceRequirement[item].label}{" "}
                                      {assistanceRequirement[item].required ? (
                                        <span style={{ color: "red" }}>*</span>
                                      ) : null}
                                    </label>
                                    <Radio.Group
                                      onChange={(e) => {
                                        if (
                                          item == "hasScholarship" &&
                                          e.target.value == true
                                        ) {
                                          setvisible("scholarshipName");
                                          setvisible("scholarshipAmount");
                                          setrequired("scholarshipName");
                                          setrequired("scholarshipAmount");
                                        } else if (
                                          item == "hasScholarship" &&
                                          e.target.value == false
                                        ) {
                                          sethidden("scholarshipName");
                                          setnotrequired("scholarshipName");
                                          sethidden("scholarshipAmount");
                                          setnotrequired("scholarshipAmount");
                                        } else if (
                                          item == "willingToRepay" &&
                                          e.target.value == true
                                        ) {
                                          setvisible("repayPercentage");
                                          setrequired("repayPercentage");
                                        } else if (
                                          item == "willingToRepay" &&
                                          e.target.value == false
                                        ) {
                                          setnotrequired("repayPercentage");
                                          sethidden("repayPercentage");
                                        }
                                        setvalue(item, e.target.value);
                                      }}
                                      value={assistanceRequirement[item].value}
                                      name={`${item}.value`}
                                    >
                                      <Space direction="horizontal">
                                        <Radio value={true}>Yes</Radio>
                                        <Radio value={false}>No</Radio>
                                      </Space>
                                      {/* <Radio value={details[item].radio}>{details[item].radio[1]}</Radio> */}
                                    </Radio.Group>
                                    {errors[item] &&
                                    item in touched &&
                                    !assistanceRequirement[item]["value"] &&
                                    touched[item]["value"] ? (
                                      <div style={{ color: "red" }}>
                                        {errors[item]}
                                      </div>
                                    ) : null}
                                  </Col>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  );
                })}
              </Row>
              <Divider orientation="left" orientationMargin={50}>
                <Typography.Title level={5}>
                  Please provide write up covering following topics/questions
                  (Maximum 1000 words)
                </Typography.Title>
              </Divider>
              <Row
                gutter={10}
                style={{ marginLeft: "50px", marginRight: "5px" }}
              >
                <ol>
                  <li>
                    Describe a significant personal achievement and its impact
                    on your life.
                  </li>
                  <li>
                    Explain a challenge you've faced and how you overcame it.
                  </li>
                  <li>
                    According to you your strengths and areas for improvement?
                  </li>
                  <li>
                    Your professional aspiration goal and your plan to achieve
                    it?
                  </li>
                </ol>
              </Row>
              <Row
                gutter={10}
                style={{ marginLeft: "50px", marginRight: "5px" }}
              >
                <Col md={12}>
                  <label>
                    {assistanceRequirement["personalStatement"].label}{" "}
                    {assistanceRequirement["personalStatement"].required ? (
                      <span style={{ color: "red" }}>*</span>
                    ) : null}
                  </label>
                  <TextArea
                    placeholder={assistanceRequirement.personalStatement.label}
                    name={`${"personalStatement"}.value`}
                    value={assistanceRequirement["personalStatement"].value}
                    onChange={(e) => {
                      setvalue("personalStatement", e.target.value);
                    }}
                    rows={4}
                    maxLength={4000}
                  />
                  {errors["personalStatement"] &&
                  "personalStatement" in touched &&
                  touched["personalStatement"]["value"] ? (
                    <div style={{ color: "red" }}>
                      {errors["personalStatement"]}
                    </div>
                  ) : null}
                </Col>
              </Row>
              <Row gutter={10} style={{ margin: "50px" }}>
                <Space direction="vertical" style={{ width: "100%" }}>
                  {alertVisible && (
                    <Alert
                      message={alertMessage}
                      type={alertType}
                      closable
                      afterClose={handleClose}
                    />
                  )}
                  {alertVisible}
                </Space>
              </Row>
              <Row gutter={10} style={{ margin: "50px" }}>
                <Col>
                  <Button type={"primary"} onClick={handleSubmit}>
                    Save
                  </Button>
                </Col>
                {/* <Col>
                <Button type={"success"} onClick={onFinish}>
                  Next
                </Button>
              </Col> */}
              </Row>
            </div>
          );
        }}
      </Formik>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};
export default AssistanceRequirement;
